"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformConstructorFacetsToFilters = void 0;
const transformConstructorFacetsToFilters = (facetsParams) => {
    return facetsParams.reduce((acc, { name, options }) => {
        acc[name] = (options || []).map(({ display_name, value, count }) => ({
            label: display_name,
            value: value,
            count: count,
        }));
        return acc;
    }, {});
};
exports.transformConstructorFacetsToFilters = transformConstructorFacetsToFilters;
